import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'isSameDay',
  pure: true,
})
export class IsSameDayPipe implements PipeTransform {
  public transform(_date: string, _dateToCompare?: string): boolean {
    const date = dayjs(_date);
    const compareDate = dayjs(_dateToCompare);

    return date.isSame(compareDate, 'day');
  }
}
